<template>
  <div class="shop">
    <div class="top" style="margin-bottom:10px">
      <el-input
        class="search-data"
        size="small"
        v-model="form.card_sn"
        placeholder="卡号"
        clearable
      ></el-input>
      <el-date-picker
        class="search-data"
        v-model="form.start_date"
        type="date"
        value-format="yyyy-MM-dd"
        size="mini"
        placeholder="开始时间"
      >
      </el-date-picker>
      <el-date-picker
        class="search-data"
        v-model="form.end_date"
        type="date"
        size="mini"
        value-format="yyyy-MM-dd"
        placeholder="结束时间"
      ></el-date-picker>
      <el-button class="search" size="small" type="primary" @click="searchList"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="codeId"></el-table-column>
      <el-table-column label="卡ID" prop="card_sn"></el-table-column>
    </el-table>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { activationCardList } from '@/api/redpacketManage'
export default {
  components: {},
  data() {
    return {
      id: '', // 卡号
      tableData: [],
      labelPosition: 'right',
      form: {
        card_sn: '',
        start_date: '',
        end_date: ''
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getactivationList()
  },
  methods: {
    //获取列表数据
    async getactivationList() {
      let url = `id=${this.id}&card_sn=${this.form.card_sn}&start_date=${
        this.form.start_date
      }&end_date=${this.form.end_date}`
      let res = await activationCardList(url)
      console.log(res)
      if (res.code === 10000) {
        this.tableData = res.data
      } else {
        this.$message.error(res.message)
      }
    },
    //搜索
    searchList() {
      this.getactivationList()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top {
    .search-data {
      width: 150px;
      height: 32px;
      margin-right: 10px;
    }
  }
  ::v-deep.el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
